import { observable, action, reaction,when, makeObservable,toJS } from 'mobx';
import axios from 'axios';

class configStore {
  route="";
  sort_mode=false;
  data={
    inited: false,
    fetching: false,
    data:{},
  };

  par=null;
  constructor(par) {
    makeObservable(this,{
      route:observable,
      data:observable,
      sort_mode:observable,
    });
    this.par=par;
    when(
      ()=>{ return this.par.configStore.config.data.data_route; },
      ()=>{
        this.refreshData();
      }
    );
    reaction(()=>{
      return this.par.memoryStore.memory_str;
    },()=>{
      this.refreshData();
    });
    reaction(()=>{
      return this.par.configStore.config.data.data_route
    },(dataRoute)=>{
      this.route=dataRoute;
      this.refreshData();
    })
  }
  updateRow(data) {
    const idField=this.par.configStore.config.data.id_field;

    const idVal=data[idField];

    const updateField=()=> {
      if (this.data.data.items) {
        for (let i in this.data.data.items) {
          if (this.data.data.items[i][idField] == idVal) {
            this.data.data.items[i] = data;
          }
        }
      }
    };

    if(this.data.inited && !this.data.fetching) {
      updateField();
    } else {
      when(()=>{ return !this.data.fetching; },()=>{
        updateField();
      })
    }

  }
  move(ids,position,to) {
    const flt=this.par.searchStore.getFilter();
    let section=null;
    if(flt.section && flt.section[0]) {
      section=flt.section[0];
    }
    const url=this.par.configStore.config.data.sort_route;
    if(url) {
      const postData={ids, position, to};
      if(section) {
        postData.section=section;
      }
      postData.order=toJS(this.par.memoryStore.memory.order);
      axios.post(url, postData).then(() => {
        this.refreshData();
      });
    }

  }
  initExport() {
    console.log('CONF', toJS(this.par.configStore.config));
    const url = this.par.configStore.config.data.export_route;
    this.data.fetching=true;
    const req=this.par.memoryStore.getRequest();
    axios.post(url, req.data).then((data)=>{
      if(data.data.answer) {
        window.location = data.data.answer;
      } else {
        alert("Ошибка экспорта");
      }
      this.data.fetching = false;
    });
  }
  refreshData() {
    if(this._ta) {
      clearTimeout(this._ta);
    }
    this._ta=setTimeout(()=>{
      this.data.fetching=true;
      const req=this.par.memoryStore.getRequest();
      this.par.communicatorStore.pushMessage({ type:"output",command:"request_changed",data:req });
      axios.post(req.url,req.data).then((data)=>{
        this.data.data=data.data.answer;
        this.data.fetching=false;
        this.data.inited=true;
      });
    },10);
  }
}

/*decorate(configStore,{
  route:observable,
  data:observable,
  sort_mode:observable,
});*/

export default configStore;
